module.exports = __webpack_public_path__ + "static/img/增白剂.17f7c88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/增白剂.jpg
// module id = 189
// module chunks = 1